var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 10.7L14.3 7.3M7.7 13.3L14.3 16.7M2 12C2 12.7956 2.31607 13.5587 2.87868 14.1213C3.44129 14.6839 4.20435 15 5 15C5.79565 15 6.55871 14.6839 7.12132 14.1213C7.68393 13.5587 8 12.7956 8 12C8 11.2044 7.68393 10.4413 7.12132 9.87868C6.55871 9.31607 5.79565 9 5 9C4.20435 9 3.44129 9.31607 2.87868 9.87868C2.31607 10.4413 2 11.2044 2 12ZM14 6C14 6.79565 14.3161 7.55871 14.8787 8.12132C15.4413 8.68393 16.2044 9 17 9C17.7956 9 18.5587 8.68393 19.1213 8.12132C19.6839 7.55871 20 6.79565 20 6C20 5.20435 19.6839 4.44129 19.1213 3.87868C18.5587 3.31607 17.7956 3 17 3C16.2044 3 15.4413 3.31607 14.8787 3.87868C14.3161 4.44129 14 5.20435 14 6ZM14 18C14 18.7956 14.3161 19.5587 14.8787 20.1213C15.4413 20.6839 16.2044 21 17 21C17.7956 21 18.5587 20.6839 19.1213 20.1213C19.6839 19.5587 20 18.7956 20 18C20 17.2044 19.6839 16.4413 19.1213 15.8787C18.5587 15.3161 17.7956 15 17 15C16.2044 15 15.4413 15.3161 14.8787 15.8787C14.3161 16.4413 14 17.2044 14 18Z",
    stroke: "#1ABB62",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerShare);
export default __webpack_public_path__ + "static/media/tabler_share.1154429e8050ef664aa542700e851f6b.svg";
export { ForwardRef as ReactComponent };